// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsAndCancellationPolicyRouteImport } from './routes/terms-and-cancellation-policy'
import { Route as SummerStaysCrystalBeachRouteImport } from './routes/summer-stays-crystal-beach'
import { Route as SmallEventsCrystalBeachRouteImport } from './routes/small-events-crystal-beach'
import { Route as SeasonalRatesMalakBnbResortRouteImport } from './routes/seasonal-rates-malak-bnb-resort'
import { Route as RoomsRouteImport } from './routes/rooms'
import { Route as ReservationDetailsRouteImport } from './routes/reservation-details'
import { Route as QueenBedSuiteCrystalBeachRouteImport } from './routes/queen-bed-suite-crystal-beach'
import { Route as MeetingsAndEventsRouteImport } from './routes/meetings-and-events'
import { Route as FortErieBedAndBreakfastRouteImport } from './routes/fort-erie-bed-and-breakfast'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as DeluxeQueenRoomCrystalBeachRouteImport } from './routes/deluxe-queen-room-crystal-beach'
import { Route as CyclingFriendlyAccommodationNiagaraRouteImport } from './routes/cycling-friendly-accommodation-niagara'
import { Route as CrystalBeachBedAndBreakfastRouteImport } from './routes/crystal-beach-bed-and-breakfast'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BookRouteImport } from './routes/book'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as R2DoubleBedsRoomCrystalBeachRouteImport } from './routes/2-double-beds-room-crystal-beach'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogWhatToKnowBeforeYourStayRouteImport } from './routes/blog.what-to-know-before-your-stay'
import { Route as BlogWeekendGetawayCrystalBeachLakeErieRouteImport } from './routes/blog.weekend-getaway-crystal-beach-lake-erie'
import { Route as BlogThingsToDoNearCrystalBeachOntarioRouteImport } from './routes/blog.things-to-do-near-crystal-beach-ontario'
import { Route as BlogRestaurantsNearCrystalBeachRouteImport } from './routes/blog.restaurants-near-crystal-beach'
import { Route as BlogOffSeasonStaysLakeErieRouteImport } from './routes/blog.off-season-stays-lake-erie'
import { Route as BlogNiagaraFallsDayTripFromCrystalBeachRouteImport } from './routes/blog.niagara-falls-day-trip-from-crystal-beach'
import { Route as BlogFallGetawayCrystalBeachNiagaraRouteImport } from './routes/blog.fall-getaway-crystal-beach-niagara'
import { Route as BlogExploringCrystalBeachByBikeRouteImport } from './routes/blog.exploring-crystal-beach-by-bike'
import { Route as BlogBayBeachCrystalBeachGuideRouteImport } from './routes/blog.bay-beach-crystal-beach-guide'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminDashboardRouteImport } from './routes/admin.dashboard'

const TermsAndCancellationPolicyRoute = TermsAndCancellationPolicyRouteImport.update({
            id: '/terms-and-cancellation-policy',path: '/terms-and-cancellation-policy',getParentRoute: () => rootRouteImport
          })
const SummerStaysCrystalBeachRoute = SummerStaysCrystalBeachRouteImport.update({
            id: '/summer-stays-crystal-beach',path: '/summer-stays-crystal-beach',getParentRoute: () => rootRouteImport
          })
const SmallEventsCrystalBeachRoute = SmallEventsCrystalBeachRouteImport.update({
            id: '/small-events-crystal-beach',path: '/small-events-crystal-beach',getParentRoute: () => rootRouteImport
          })
const SeasonalRatesMalakBnbResortRoute = SeasonalRatesMalakBnbResortRouteImport.update({
            id: '/seasonal-rates-malak-bnb-resort',path: '/seasonal-rates-malak-bnb-resort',getParentRoute: () => rootRouteImport
          })
const RoomsRoute = RoomsRouteImport.update({
            id: '/rooms',path: '/rooms',getParentRoute: () => rootRouteImport
          })
const ReservationDetailsRoute = ReservationDetailsRouteImport.update({
            id: '/reservation-details',path: '/reservation-details',getParentRoute: () => rootRouteImport
          })
const QueenBedSuiteCrystalBeachRoute = QueenBedSuiteCrystalBeachRouteImport.update({
            id: '/queen-bed-suite-crystal-beach',path: '/queen-bed-suite-crystal-beach',getParentRoute: () => rootRouteImport
          })
const MeetingsAndEventsRoute = MeetingsAndEventsRouteImport.update({
            id: '/meetings-and-events',path: '/meetings-and-events',getParentRoute: () => rootRouteImport
          })
const FortErieBedAndBreakfastRoute = FortErieBedAndBreakfastRouteImport.update({
            id: '/fort-erie-bed-and-breakfast',path: '/fort-erie-bed-and-breakfast',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ExploreRoute = ExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => rootRouteImport
          })
const DeluxeQueenRoomCrystalBeachRoute = DeluxeQueenRoomCrystalBeachRouteImport.update({
            id: '/deluxe-queen-room-crystal-beach',path: '/deluxe-queen-room-crystal-beach',getParentRoute: () => rootRouteImport
          })
const CyclingFriendlyAccommodationNiagaraRoute = CyclingFriendlyAccommodationNiagaraRouteImport.update({
            id: '/cycling-friendly-accommodation-niagara',path: '/cycling-friendly-accommodation-niagara',getParentRoute: () => rootRouteImport
          })
const CrystalBeachBedAndBreakfastRoute = CrystalBeachBedAndBreakfastRouteImport.update({
            id: '/crystal-beach-bed-and-breakfast',path: '/crystal-beach-bed-and-breakfast',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const R2DoubleBedsRoomCrystalBeachRoute = R2DoubleBedsRoomCrystalBeachRouteImport.update({
            id: '/2-double-beds-room-crystal-beach',path: '/2-double-beds-room-crystal-beach',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogWhatToKnowBeforeYourStayRoute = BlogWhatToKnowBeforeYourStayRouteImport.update({
            id: '/what-to-know-before-your-stay',path: '/what-to-know-before-your-stay',getParentRoute: () => BlogRoute
          })
const BlogWeekendGetawayCrystalBeachLakeErieRoute = BlogWeekendGetawayCrystalBeachLakeErieRouteImport.update({
            id: '/weekend-getaway-crystal-beach-lake-erie',path: '/weekend-getaway-crystal-beach-lake-erie',getParentRoute: () => BlogRoute
          })
const BlogThingsToDoNearCrystalBeachOntarioRoute = BlogThingsToDoNearCrystalBeachOntarioRouteImport.update({
            id: '/things-to-do-near-crystal-beach-ontario',path: '/things-to-do-near-crystal-beach-ontario',getParentRoute: () => BlogRoute
          })
const BlogRestaurantsNearCrystalBeachRoute = BlogRestaurantsNearCrystalBeachRouteImport.update({
            id: '/restaurants-near-crystal-beach',path: '/restaurants-near-crystal-beach',getParentRoute: () => BlogRoute
          })
const BlogOffSeasonStaysLakeErieRoute = BlogOffSeasonStaysLakeErieRouteImport.update({
            id: '/off-season-stays-lake-erie',path: '/off-season-stays-lake-erie',getParentRoute: () => BlogRoute
          })
const BlogNiagaraFallsDayTripFromCrystalBeachRoute = BlogNiagaraFallsDayTripFromCrystalBeachRouteImport.update({
            id: '/niagara-falls-day-trip-from-crystal-beach',path: '/niagara-falls-day-trip-from-crystal-beach',getParentRoute: () => BlogRoute
          })
const BlogFallGetawayCrystalBeachNiagaraRoute = BlogFallGetawayCrystalBeachNiagaraRouteImport.update({
            id: '/fall-getaway-crystal-beach-niagara',path: '/fall-getaway-crystal-beach-niagara',getParentRoute: () => BlogRoute
          })
const BlogExploringCrystalBeachByBikeRoute = BlogExploringCrystalBeachByBikeRouteImport.update({
            id: '/exploring-crystal-beach-by-bike',path: '/exploring-crystal-beach-by-bike',getParentRoute: () => BlogRoute
          })
const BlogBayBeachCrystalBeachGuideRoute = BlogBayBeachCrystalBeachGuideRouteImport.update({
            id: '/bay-beach-crystal-beach-guide',path: '/bay-beach-crystal-beach-guide',getParentRoute: () => BlogRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminDashboardRoute = AdminDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminDashboardRoute: AdminDashboardRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const BlogRouteChildren = {
  BlogBayBeachCrystalBeachGuideRoute: BlogBayBeachCrystalBeachGuideRoute,BlogExploringCrystalBeachByBikeRoute: BlogExploringCrystalBeachByBikeRoute,BlogFallGetawayCrystalBeachNiagaraRoute: BlogFallGetawayCrystalBeachNiagaraRoute,BlogNiagaraFallsDayTripFromCrystalBeachRoute: BlogNiagaraFallsDayTripFromCrystalBeachRoute,BlogOffSeasonStaysLakeErieRoute: BlogOffSeasonStaysLakeErieRoute,BlogRestaurantsNearCrystalBeachRoute: BlogRestaurantsNearCrystalBeachRoute,BlogThingsToDoNearCrystalBeachOntarioRoute: BlogThingsToDoNearCrystalBeachOntarioRoute,BlogWeekendGetawayCrystalBeachLakeErieRoute: BlogWeekendGetawayCrystalBeachLakeErieRoute,BlogWhatToKnowBeforeYourStayRoute: BlogWhatToKnowBeforeYourStayRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,R2DoubleBedsRoomCrystalBeachRoute: R2DoubleBedsRoomCrystalBeachRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,BlogRoute: BlogRouteWithChildren,BookRoute: BookRoute,ContactRoute: ContactRoute,CrystalBeachBedAndBreakfastRoute: CrystalBeachBedAndBreakfastRoute,CyclingFriendlyAccommodationNiagaraRoute: CyclingFriendlyAccommodationNiagaraRoute,DeluxeQueenRoomCrystalBeachRoute: DeluxeQueenRoomCrystalBeachRoute,ExploreRoute: ExploreRoute,FaqRoute: FaqRoute,FortErieBedAndBreakfastRoute: FortErieBedAndBreakfastRoute,MeetingsAndEventsRoute: MeetingsAndEventsRoute,QueenBedSuiteCrystalBeachRoute: QueenBedSuiteCrystalBeachRoute,ReservationDetailsRoute: ReservationDetailsRoute,RoomsRoute: RoomsRoute,SeasonalRatesMalakBnbResortRoute: SeasonalRatesMalakBnbResortRoute,SmallEventsCrystalBeachRoute: SmallEventsCrystalBeachRoute,SummerStaysCrystalBeachRoute: SummerStaysCrystalBeachRoute,TermsAndCancellationPolicyRoute: TermsAndCancellationPolicyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)